'use strict';

exports.__esModule = true;
exports.inserted = exports.sheet = undefined;
exports.flush = flush;
exports.css = css;
exports.injectGlobal = injectGlobal;
exports.fontFace = fontFace;
exports.keyframes = keyframes;
exports.hydrate = hydrate;
exports.objStyle = objStyle;
exports.isLikeRule = isLikeRule;
exports.idFor = idFor;

var _sheet = require('./sheet');

var _utils = require('./utils');

var _hash = require('./hash');

var _CSSPropertyOperations = require('./glamor/CSSPropertyOperations');

var _clean = require('./glamor/clean.js');

var _clean2 = _interopRequireDefault(_clean);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sheet = exports.sheet = new _sheet.StyleSheet();
// 🚀

sheet.inject();

var inserted = exports.inserted = {};

function flush() {
  sheet.flush();
  exports.inserted = inserted = {};
  sheet.inject();
}

// a simple cache to store generated obj styles
var registered = sheet.registered = {};

function register(spec) {
  if (!registered[spec.id]) {
    registered[spec.id] = spec;
  }
}

function _getRegistered(rule) {
  if (isLikeRule(rule)) {
    var ret = registered[idFor(rule)];
    if (ret == null) {
      throw new Error('[emotion] an unexpected rule cache miss occurred. This is probably a sign of multiple glamor instances in your app. See https://github.com/threepointone/glamor/issues/79');
    }
    return ret;
  }
  return rule;
}

function buildStyles(objs) {
  var computedClassName = '';
  var objectStyles = [];
  // This needs to be moved into the core
  (0, _utils.forEach)(objs, function (cls) {
    if (typeof cls === 'string') {
      var match = emotionClassRegex.exec(cls);
      if (match !== null && ruleCache[match[1]] !== undefined) {
        objectStyles.push(ruleCache[match[1]]);
      } else {
        computedClassName && (computedClassName += ' ');
        computedClassName += cls;
      }
    } else {
      objectStyles.push(cls);
    }
  });

  return { computedClassName: computedClassName, objectStyles: objectStyles };
}

function css(objs, vars, content) {
  if (!Array.isArray(objs)) {
    objs = [objs];
  }

  var _buildStyles = buildStyles(content ? objs.concat(content.apply(null, vars)) : objs),
      _buildStyles$computed = _buildStyles.computedClassName,
      computedClassName = _buildStyles$computed === undefined ? '' : _buildStyles$computed,
      _buildStyles$objectSt = _buildStyles.objectStyles,
      objectStyles = _buildStyles$objectSt === undefined ? [] : _buildStyles$objectSt;

  if (objectStyles.length) {
    computedClassName += ' ' + objStyle.apply(null, objectStyles).toString();
  }

  return computedClassName.trim();
}

function insertRawRule(css) {
  var spec = {
    id: (0, _hash.hashString)(css),
    css: css,
    type: 'raw'
  };

  register(spec);

  if (!inserted[spec.id]) {
    sheet.insert(spec.css);
    inserted[spec.id] = true;
  }
}

function injectGlobal(objs, vars, content) {
  var combined = content ? objs.concat(content.apply(null, vars)) : objs;

  // injectGlobal is flattened by postcss
  // we don't support nested selectors on objects
  (0, _utils.forEach)(combined, function (obj) {
    (0, _utils.forEach)((0, _utils.keys)(obj), function (selector) {
      insertRawRule(selector + ' {' + (0, _CSSPropertyOperations.createMarkupForStyles)(obj[selector]) + '}');
    });
  });
}

function fontFace(objs, vars, content) {
  var combined = (0, _utils.reduce)(content ? objs.concat(content.apply(null, vars)) : objs, function (accum, item, i) {
    return (0, _utils.assign)(accum, item);
  }, {});

  insertRawRule('@font-face{' + (0, _CSSPropertyOperations.createMarkupForStyles)(combined) + '}');
}

function insertKeyframe(spec) {
  if (!inserted[spec.id]) {
    var inner = (0, _utils.map)((0, _utils.keys)(spec.keyframes), function (kf) {
      return kf + ' {' + (0, _CSSPropertyOperations.createMarkupForStyles)(spec.keyframes[kf]) + '}';
    }).join('');

    (0, _utils.forEach)(['-webkit-', ''], function (prefix) {
      return sheet.insert('@' + prefix + 'keyframes ' + (spec.name + '_' + spec.id) + '{' + inner + '}');
    });

    inserted[spec.id] = true;
  }
}

function keyframes(objs, vars, content) {
  var _content$apply = content.apply(null, vars),
      kfs = _content$apply[0];

  var name = 'animation';

  var spec = {
    id: (0, _hash.hashObject)(kfs),
    type: 'keyframes',
    name: name,
    keyframes: kfs
  };

  register(spec);
  insertKeyframe(spec);
  return name + '_' + spec.id;
}

function hydrate(ids) {
  (0, _utils.forEach)(ids, function (id) {
    return inserted[id] = true;
  });
}

var cachedCss = typeof WeakMap !== 'undefined' ? multiIndexCache(_css) : _css;

// 🍩
// https://github.com/threepointone/glamor
function objStyle() {
  for (var _len = arguments.length, rules = Array(_len), _key = 0; _key < _len; _key++) {
    rules[_key] = arguments[_key];
  }

  rules = (0, _clean2.default)(rules);
  if (!rules) {
    return nullrule;
  }

  return cachedCss(rules);
}

function _css(rules) {
  var style = {};
  build(style, { src: rules }); // mutative! but worth it.

  var spec = {
    id: (0, _hash.hashObject)(style),
    style: style,
    type: 'css'
  };
  return toRule(spec);
}

var emotionClassRegex = /css-([a-zA-Z0-9]+)/;

// of shape { 'data-css-<id>': '' }
function isLikeRule(rule) {
  var ruleKeys = (0, _utils.keys)(rule);
  if (ruleKeys.length !== 1) {
    return false;
  }
  return !!emotionClassRegex.exec(ruleKeys[0]);
}

// extracts id from a { 'css-<id>': ''} like object
function idFor(rule) {
  var ruleKeys = (0, _utils.keys)(rule);
  if (ruleKeys.length !== 1) throw new Error('not a rule');
  var match = emotionClassRegex.exec(ruleKeys[0]);
  if (!match) throw new Error('not a rule');
  return match[1];
}

var parentSelectorRegex = /&/gm;

function selector(id) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!id) {
    return path.replace(parentSelectorRegex, '');
  }
  if (!path) return '.css-' + id;

  var x = (0, _utils.map)(path.split(','), function (x) {
    return x.indexOf('&') >= 0 ? x.replace(parentSelectorRegex, '.css-' + id) : '.css-' + id + x;
  }).join(',');

  return x;
}

function deconstruct(style) {
  // we can be sure it's not infinitely nested here
  var plain = void 0;
  var selects = void 0;
  var medias = void 0;
  var supports = void 0;

  (0, _utils.forEach)((0, _utils.keys)(style), function (key) {
    if (key.indexOf('&') >= 0) {
      selects = selects || {};
      selects[key] = deconstruct(style[key]).plain;
    } else if (key.indexOf('@media') === 0) {
      medias = medias || {};
      medias[key] = deconstruct(style[key]);
    } else if (key.indexOf('@supports') === 0) {
      supports = supports || {};
      supports[key] = deconstruct(style[key]);
    } else {
      plain = plain || {};

      plain[key] = style[key];
    }
  });
  return { plain: plain, selects: selects, medias: medias, supports: supports };
}

function deconstructedStyleToCSS(id, style) {
  var plain = style.plain,
      selects = style.selects,
      medias = style.medias,
      supports = style.supports;

  var css = [];

  if (plain) {
    css.push(selector(id) + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(plain) + '}');
  }
  if (selects) {
    (0, _utils.forEach)((0, _utils.keys)(selects), function (key) {
      return css.push(selector(id, key) + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(selects[key]) + '}');
    });
  }
  if (medias) {
    (0, _utils.forEach)((0, _utils.keys)(medias), function (key) {
      return css.push(key + '{' + deconstructedStyleToCSS(id, medias[key]).join('') + '}');
    });
  }
  if (supports) {
    (0, _utils.forEach)((0, _utils.keys)(supports), function (key) {
      return css.push(key + '{' + deconstructedStyleToCSS(id, supports[key]).join('') + '}');
    });
  }
  return css;
}

// and helpers to insert rules into said sheet
function insert(spec) {
  if (!inserted[spec.id]) {
    inserted[spec.id] = true;
    var deconstructed = deconstruct(spec.style);
    (0, _utils.map)(deconstructedStyleToCSS(spec.id, deconstructed), function (cssRule) {
      return sheet.insert(cssRule);
    });
  }
}

// todo - perf
var ruleCache = {};

function toRule(spec) {
  var _ret;

  register(spec);
  insert(spec);
  if (ruleCache[spec.id]) {
    return ruleCache[spec.id];
  }

  var ret = (_ret = {}, _ret['css-' + spec.id] = '', _ret);
  Object.defineProperty(ret, 'toString', {
    enumerable: false,
    value: function value() {
      return 'css-' + spec.id;
    }
  });
  ruleCache[spec.id] = ret;
  return ret;
}

function isFragment(key) {
  return key.indexOf('$') === 0;
}

function isSelector(key) {
  var possibles = [':', '.', '[', '>', ' '];
  var found = false;
  var ch = key.charAt(0);
  for (var i = 0; i < possibles.length; i++) {
    if (ch === possibles[i]) {
      found = true;
      break;
    }
  }
  return found || key.indexOf('&') >= 0;
}

function joinSelectors(a, b) {
  var as = (0, _utils.map)(a.split(','), function (a) {
    return !(a.indexOf('&') >= 0) ? '&' + a : a;
  });
  var bs = (0, _utils.map)(b.split(','), function (b) {
    return !(b.indexOf('&') >= 0) ? '&' + b : b;
  });

  return (0, _utils.reduce)(bs, function (arr, b) {
    return arr.concat((0, _utils.map)(as, function (a) {
      return b.replace(parentSelectorRegex, a);
    }));
  }, []).join(',');
}

function joinMediaQueries(a, b) {
  return a ? '@media ' + a.substring(6) + ' and ' + b.substring(6) : b;
}

function isMediaQuery(key) {
  return key.indexOf('@media') === 0;
}

function isSupports(key) {
  return key.indexOf('@supports') === 0;
}

function joinSupports(a, b) {
  return a ? '@supports ' + a.substring(9) + ' and ' + b.substring(9) : b;
}

// flatten a nested array
function flatten(inArr) {
  var arr = [];
  (0, _utils.forEach)(inArr, function (val) {
    if (Array.isArray(val)) arr = arr.concat(flatten(val));else arr = arr.concat(val);
  });

  return arr;
}

// mutable! modifies dest.
function build(dest, _ref) {
  var _ref$selector = _ref.selector,
      selector = _ref$selector === undefined ? '' : _ref$selector,
      _ref$mq = _ref.mq,
      mq = _ref$mq === undefined ? '' : _ref$mq,
      _ref$supp = _ref.supp,
      supp = _ref$supp === undefined ? '' : _ref$supp,
      _ref$src = _ref.src,
      src = _ref$src === undefined ? [{}] : _ref$src;

  if (!Array.isArray(src)) {
    src = [src];
  }
  src = flatten(src);
  (0, _utils.forEach)(src, function (_src) {
    if (isLikeRule(_src)) {
      var reg = _getRegistered(_src);
      if (reg.type !== 'css') {
        throw new Error('cannot merge this rule');
      }
      _src = reg.style;
    }
    _src = (0, _clean2.default)(_src);
    if (_src && _src.composes) {
      build(dest, { selector: selector, mq: mq, supp: supp, src: _src.composes });
    }

    (0, _utils.forEach)((0, _utils.keys)(_src || {}), function (key) {
      // replace fragments
      if (isFragment(key)) {
        var fragment = _src[key];

        if (typeof fragment === 'string') {
          var match = emotionClassRegex.exec(fragment);
          if (match !== null && registered[match[1]]) {
            var _reg = registered[match[1]];
            if (_reg.type !== 'css') {
              throw new Error('cannot merge this rule');
            }
            build(dest, {
              selector: selector,
              mq: mq,
              supp: supp,
              src: _reg.style
            });
          }
        } else {
          build(dest, {
            selector: selector,
            mq: mq,
            supp: supp,
            src: fragment
          });
        }
      } else if (isSelector(key)) {
        build(dest, {
          selector: joinSelectors(selector, key),
          mq: mq,
          supp: supp,
          src: _src[key]
        });
      } else if (isMediaQuery(key)) {
        build(dest, {
          selector: selector,
          mq: joinMediaQueries(mq, key),
          supp: supp,
          src: _src[key]
        });
      } else if (isSupports(key)) {
        build(dest, {
          selector: selector,
          mq: mq,
          supp: joinSupports(supp, key),
          src: _src[key]
        });
      } else if (key === 'composes') {
        // ignore, we already dealt with it
      } else {
        var _dest = dest;
        if (supp) {
          _dest[supp] = _dest[supp] || {};
          _dest = _dest[supp];
        }
        if (mq) {
          _dest[mq] = _dest[mq] || {};
          _dest = _dest[mq];
        }
        if (selector) {
          _dest[selector] = _dest[selector] || {};
          _dest = _dest[selector];
        }

        _dest[key] = _src[key];
      }
    });
  });
}

var nullrule = {
  // 'data-css-nil': ''
};

Object.defineProperty(nullrule, 'toString', {
  enumerable: false,
  value: function value() {
    return 'css-nil';
  }
});

var inputCaches = typeof WeakMap !== 'undefined' ? [nullrule, new WeakMap(), new WeakMap(), new WeakMap()] : [nullrule];

var warnedWeakMapError = false;

function multiIndexCache(fn) {
  return function (args) {
    if (inputCaches[args.length]) {
      var coi = inputCaches[args.length];
      var ctr = 0;
      while (ctr < args.length - 1) {
        if (!coi.has(args[ctr])) {
          coi.set(args[ctr], new WeakMap());
        }
        coi = coi.get(args[ctr]);
        ctr++;
      }
      if (coi.has(args[args.length - 1])) {
        var ret = coi.get(args[ctr]);

        if (registered[ret.toString().substring(4)]) {
          // make sure it hasn't been flushed
          return ret;
        }
      }
    }
    var value = fn(args);
    if (inputCaches[args.length]) {
      var _ctr = 0;
      var _coi = inputCaches[args.length];
      while (_ctr < args.length - 1) {
        _coi = _coi.get(args[_ctr]);
        _ctr++;
      }
      try {
        _coi.set(args[_ctr], value);
      } catch (err) {
        if ((process.env.NODE_ENV === 'development' || !process.env.NODE_ENV) && !warnedWeakMapError) {
          var _console;

          warnedWeakMapError = true;
          (_console = console).warn.apply(_console, ['failed setting the WeakMap cache for args:'].concat(args)); // eslint-disable-line no-console
          console.warn('this should NOT happen, please file a bug on the github repo.'); // eslint-disable-line no-console
        }
      }
    }
    return value;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/emotion/lib/index.js
// module id = 37
// module chunks = 0